import { PageProps, graphql } from 'gatsby';
import * as React from 'react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { getCmsComponent } from '../utils/cmsComponentHelpers';
import { getHelmetPropsFromMetatagProps, getJsonFromMetatagProps } from '../utils/metatagHelpers';

interface NodePageProps extends NodeContent {
  relationships?: {
    components: TCmsComponents[];
  };
}
interface DataProps {
  node: NodePageProps;
  translations: Translations;
}

const HomePageTemplate: React.FC<PageProps<DataProps>> = function ({ data: { node } }) {
  const components = node.relationships?.components;
  const helmetProps = getHelmetPropsFromMetatagProps(node.metatag);
  const schemaMarkup = getJsonFromMetatagProps(node.metatag);
  return (
    <Layout node={node} metaData={node.metatag} language={node.langcode}>
      <Seo {...helmetProps} schemaMarkup={schemaMarkup} />
      {components &&
        components.map((component, index) => {
          return (
            <React.Fragment key={component.id}>
              {getCmsComponent({ node: component, index })}
            </React.Fragment>
          );
        })}
    </Layout>
  );
};

export const query = graphql`
  query ($id: String!, $language: String!) {
    node: nodeHomePage(id: { eq: $id }, langcode: { eq: $language }) {
      internal {
        type
      }
      id
      path {
        alias
      }
      ...Metatag
      langcode
      title
      relationships {
        components: field_storage {
          type: __typename
          ...StorageArticleCards
          ...StorageImageContent
          ...StorageHeroCard
          ...StorageManualCards
          ...StorageHighlights
          ...StorageProductCards
          ...StorageRichText
          ...StoragePageTitle
          ...StorageBanner
          ...StorageAnsiraProfileForm
          ...StorageIngredientsMap
          ...StorageBrandGrid
          ...StorageFaqSection
          ...StorageUnfilteredHtml
          ...StorageSubnav
          ...StorageCardGrid
          ...StorageReviews
          ...StorageCategoryCards
          ...StorageContactCards
          ...StorageVideo
          ...StorageNewsletterSignUpForm
          ...StoragePuppyAdoptersForm
          ...StorageKittenAdoptersForm
          ...StorageFreeSampleForm
          ...StorageHeroCarousel
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default HomePageTemplate;
